export default "__VITE_ASSET__CCvQ1wqp__"